import React, { useEffect, useState } from "react";
import api from "../../../lib/api";
import { logger } from "../../../lib/logger";
import { useBiz } from "./i18n";
import { Big, Card, Row } from "./ui";

export function SimpleOverview() {
  const { t, aed } = useBiz();
  const [period, setPeriod] = useState("all");
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get(`/admin/simple/overview?period=${period}`).then((r) => setD(r.data)).catch((e) => logger.error("overview", e));
  }, [period]);
  return (
    <div data-testid="biz-overview">
      <div className="inline-flex bg-white border border-[#EEE5D8] rounded-full p-1 mb-5">
        {["all", "month"].map((p) => (
          <button key={p} onClick={() => setPeriod(p)} data-testid={`biz-period-${p}`}
            className={`rounded-full px-4 py-2 text-sm transition-colors ${period === p ? "bg-[#1C1A17] text-[#FAF7F2]" : "text-[#6B645A]"}`}>{t(p === "all" ? "all_time" : "this_month")}</button>
        ))}
      </div>
      {!d ? <p className="text-[#8A8173]">…</p> : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            <Big label={t("total_sales")} value={aed(d.revenue)} testid="biz-total-sales" />
            <Big label={t("total_expenses")} value={aed(d.expenses)} testid="biz-total-expenses" />
            <Big label={t("est_profit")} value={aed(d.profit)} tone={d.profit < 0 ? "#B3412E" : "#2F6B3A"} testid="biz-est-profit" />
            <Big label={t("bottles_remaining")} value={d.bottles_remaining} testid="biz-bottles-remaining" />
          </div>
          <Card className="mt-4" testid="biz-overview-detail">
            <Row label={t("bottles_sold")} value={d.bottles_sold} />
            <Row label={t("cost_of_sold")} value={aed(d.cost_of_sold)} />
            <Row label={t("batch_spending")} value={aed(d.batch_spending)} />
            <Row label={t("general_expenses")} value={aed(d.general_expenses)} />
            <p className="text-xs text-[#8A8173] mt-3 leading-relaxed">{t("profit_hint")}</p>
          </Card>
        </>
      )}
    </div>
  );
}
